import React, {useEffect, useState} from "react";
import styled from "styled-components";
import {Button} from "antd";
import usePortalService from "../../services/PortalService";
import { useParams } from 'react-router-dom';
import emptyLike from '../../images/emptyLike.svg';
import fillLike from '../../images/fillLike.svg';
import { ManagerNavbar } from "../../Components/Navbars";
import { Reaction } from "./Reaction";
import { ApplyReaction } from "../../Components/Modals/ApplyReaction";
import { DenyReaction } from "../../Components/Modals/DenyReaction";
import { ReactionStatus } from "../../Enums/ReactionStatus";
import { Reaction as ReactionType } from "../../types";

const Footer = styled.footer`
  position: sticky;
  height: 72px;
  background: #FFFFFF;
  width: 100vw;
  max-width: 100%;
  padding: 16px 6vw 16px 6%;
  transition: box-shadow 200ms ease-in-out;

  @media only screen and (max-width: 700px) {
    width: calc(12% + 700px);
  }
  
  &.with-border {
    box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.1);
  }

  &.without-border {
    box-shadow: none;
  }
`

let reactionId: string;
export const ReactionForEmployer = () => {

  const {addInFavoriteProfiles, deleteFromFavoriteProfiles, getReactionById} = usePortalService();

  const params = useParams();
  reactionId = params.id as string;

  const [isBottom, setIsBottom] = useState<boolean | null>(false)
  
  const [reaction, setReaction] = useState<ReactionType>();
  const [reactionStatus, setReactionStatus] = useState<number>(0);
  const [isFavorite, setIsFavorite] = useState(false);
  
  const [isApplyOpen, setIsApplyOpen] = useState(false);
  const [isDenyOpen, setIsDenyOpen] = useState(false);

  const [queryError, setQueryError] = useState('');

  const handleScroll = () => {
    const element = document.getElementById("main");
    setIsBottom(element && element.getBoundingClientRect().bottom - window.innerHeight <= 30)
  }

  const favouriteHandle = async (e: React.MouseEvent) => {
      e.preventDefault();
      if (isFavorite) {
          const result = await deleteFromFavoriteProfiles({
            profileId: String(reaction?.profile.id)
          });
  
          if (result.success) {
            setIsFavorite(false)
          }
      } else {
          const result = await addInFavoriteProfiles({
            profileId: String(reaction?.profile.id)
          });
  
          if (result.success) {
            setIsFavorite(true)
          }
      }
  };

  const showModalApply = async (e: React.MouseEvent) => {
      e.preventDefault();
      if (reactionStatus === ReactionStatus.NotView || reactionStatus === ReactionStatus.View) {
          setIsApplyOpen(true);
      }
  };

  const closeModalApply = () => {
      setIsApplyOpen(false);
  };

  const showModalDeny = async (e: React.MouseEvent) => {
      e.preventDefault();
      if (reactionStatus === ReactionStatus.NotView || reactionStatus === ReactionStatus.View) {
          setIsDenyOpen(true);
      }
  };

  const closeModalDeny = () => {
      setIsDenyOpen(false);
  };

  useEffect(() => {

    handleScroll()
    window.addEventListener("scroll", () => handleScroll());
    window.addEventListener("resize", () => handleScroll());

    (
      async () => {
        getReactionById(reactionId).then(result => {
          if (result.success) {
            setReaction(result.reaction);
            setIsFavorite(result.reaction.profile.isFavorite);
            setReactionStatus(result.reaction.status);
            setQueryError('');
          }
          else {
            setQueryError(result.errors);
          }
        })
      }
    )()
  },[])

  return(
    <>
      <ManagerNavbar />
      <Reaction reaction={reaction} />
      <Footer className={isBottom ? "without-border" : "with-border"}>
        <div className="different-edges-container" style={{maxWidth: '700px'}}>
          <div className="d-flex gap-3">
            {(reactionStatus === 0 || reactionStatus === 1) && 
            <Button 
              type="primary" 
              style={{height:'32px', padding: '5px 16px', marginRight: '16px'}}
              onClick={showModalApply}> 
              Пригласить 
            </Button>}
            {(reactionStatus === 0 || reactionStatus === 1) && 
            <Button 
              danger 
              style={{height:'32px', padding: '5px 16px'}} 
              onClick={showModalDeny}>
               Отказать
            </Button>}
            {(reactionStatus === 3) && <button className="green-button" style={{height:'32px', padding: '5px 16px', marginRight: '16px'}}> Приглашение отправлено </button>}
            {(reactionStatus === 2) && <button className="red-button" style={{height:'32px', padding: '5px 16px', marginRight: '16px'}}> Отказано </button>}
          </div>
          <div className="right-edge" style={{paddingTop:'5px'}}>
              <p className="ant-btn-text" style={{cursor:'pointer', height:'22px'}} onClick={favouriteHandle}>
                  {(isFavorite === true) && <div> <img src={fillLike} /> В избранном </div>}
                  {(isFavorite === false) && <div> <img src={emptyLike} /> Сохранить в избранное </div>}
              </p>
          </div>
        </div>
      </Footer>
      <ApplyReaction isOpen={isApplyOpen} close={closeModalApply} reactionId={reaction?.id} setStatus={setReactionStatus}/>
      <DenyReaction isOpen={isDenyOpen} close={closeModalDeny} reactionId={reaction?.id} setStatus={setReactionStatus}/>
    </>
  )
}